'use client';
import styled from 'styled-components';
import {hover, primary, text} from '@/styles/globalStyleVars';
import { Container } from 'react-bootstrap';
import React, { useRef, useEffect, useState } from 'react';
import reactHtmlParser from "react-html-parser";
import {useGSAP} from "@gsap/react";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import gsap from "gsap";
import Select, {components} from "react-select";
import {usePathname} from "next/navigation";


gsap.registerPlugin(ScrollTrigger);

const MyComponent = ({data}) => {
    const pathname = usePathname();
    const listRef = useRef(null);

    useGSAP(() => {
        let scrollTrigger;

        if (listRef.current) {
            setTimeout(() => {
                scrollTrigger = ScrollTrigger.create({
                    trigger: listRef.current,
                    start: "top top",
                    endTrigger: ".footer",
                    end: "bottom bottom",
                    pin: true,
                    pinSpacing: false,
                    scrub: true,
                    markers: false,
                    onEnter: () => {
                        document.body.classList.add('service-menu');
                    },
                    onLeaveBack: () => {
                        document.body.classList.remove('service-menu');
                    },
                    onLeave: () => {
                        document.body.classList.remove('service-menu');
                    }
                });
                ScrollTrigger.refresh();
            }, 100); // adjust the delay as necessary
            data?.forEach((_, index) => {
                ScrollTrigger.create({
                    trigger: `#download${index + 1}`,
                    start: "top center",
                    end: "bottom center",
                    onEnter: () => handleSectionEnter(index),
                    onEnterBack: () => handleSectionEnter(index),
                    onLeave: () => handleSectionLeave(index),
                    onLeaveBack: () => handleSectionLeave(index),
                });
            });
        }

        // Clean up on unmount
        return () => {
            if (scrollTrigger) scrollTrigger.kill();
        };
    }, [data, pathname]);
    const handleSectionEnter = (index) => {
        // Remove active class from all links
        listRef?.current?.querySelectorAll('a').forEach((item) => item.classList.remove('active'));

        // Add active class to the current link
        const currentLink = listRef?.current?.querySelector(`a[href='#download${index + 1}']`);
        if (currentLink) {
            currentLink.classList.add('active');
        }
    };

    const handleSectionLeave = (index) => {
        // Optionally handle when the section leaves the viewport
        const currentLink = listRef?.current?.querySelector(`a[href='#download${index + 1}']`);
        if (currentLink) {
            currentLink.classList.remove('active');
        }
    };


    const handleItemClick = (e, index, sectionId) => {
        e.preventDefault();

        // Remove active class from all links
        listRef.current.querySelectorAll('a').forEach((item) => item.classList.remove('active'));

        // Add active class to the clicked link
        e.target.classList.add('active');

        // Scroll to the section within the ScrollSmoother context
        gsap.to(window, {
            scrollTo: { y: sectionId, offsetY: 0 },
            duration: 1
        });
    };

    // Create options for React Select
    const options = data?.map((element, index) => ({
        value: `#download${index + 1}`,
        label: reactHtmlParser(element?.section_data?.subtitle),
    }));

    const handleSelectChange = (selectedOption) => {
        // Scroll to the selected section
        gsap.to(window, {
            scrollTo: { y: selectedOption.value, offsetY: 0 },
            duration: 1
        });
    };
    const customStyles = {
        dropdownIndicator: (base, state) => ({
            ...base,
            transition: "all .2s ease",
            transform: state.selectProps.menuIsOpen && "rotate(180deg)"
        }),
        control: (base, state) => ({
            ...base,
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            borderRadius: 0,
            paddingLeft: 30,
            paddingRight: 30,
            color: '#FFF',
            height: 60,
            zIndex: 10,
            boxShadow: state.isFocused ? null : null,
            "&:hover": {
                borderColor: `${hover}`
            },
        }),

        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#638297' : '#FFF',
            "&:hover": {
                backgroundColor: "transparent",
                color: `${text}`,
                cursor: 'pointer'
            },
        }),
        indicatorContainer: (base, state) => ({
            ...base,
            transform: state.selectProps.menuIsOpen && "rotate(180deg)"
        })
    };

    const CaretDownIcon = () => {
        return <img src={'/images/static/down.svg'} style={{width: 12, height: 6}}/>;
    };

    const DropdownIndicator = props => {
        return (
            <components.DropdownIndicator {...props}>
                <CaretDownIcon/>
            </components.DropdownIndicator>
        );
    };
    return (
        <StyledComponent ref={listRef} id={'form-list'}>
            <Container>
                <div className="for-mobile">
                    <Select
                        styles={customStyles}
                        options={options}
                        onChange={handleSelectChange}
                        placeholder="Select an Option"
                        components={{DropdownIndicator}}
                        isSearchable={false}  // Disable typing

                    />
                </div>
                <ul>
                    {
                        data?.map((element, i) => {
                            return (
                                <li key={i}>
                                    <a
                                        href={`#download${i + 1}`}
                                        onClick={(e) => handleItemClick(e, i, `#download${i + 1}`)}
                                    >
                                        {element?.section_data?.subtitle}
                                    </a>
                                </li>
                            )
                        })

                    }

                </ul>
            </Container>
        </StyledComponent>
    );
};

const StyledComponent = styled.section`
    background-color: ${hover};
    z-index: 999999999;
    position: relative;

    ul {
        display: flex;
        overflow-x: auto;
        scroll-snap-type: x mandatory;
        -webkit-overflow-scrolling: touch;
        padding: 0;
        margin: 0;
        list-style: none;

        li {
            flex: 0 0 auto;
            scroll-snap-align: start;
            margin-right: 30px;
            padding: 30px 0;

            a {
                font-size: 18px;
                line-height: 24px;
                color: rgba(255, 255, 255, 0.7);
                font-weight: 500;
                transition: all 0.5s ease-in-out;

                &:hover {
                    color: #fff !important;
                }

                &.active {
                    color: #fff;
                }
            }
        }

        @media (max-width: 767px) {
            flex-direction: row;
            li {
                padding: 15px 0;

                a {
                    text-align: center;
                    width: 100%;
                    display: block;
                }
            }
        }
    }

    &.fixed-inner-menu {
        position: fixed;
        top: 0; /* Fixed at the top of the viewport */
        width: 100%;
        background-color: ${primary};
        z-index: 1000; /* To ensure it's above other content */
    }

    .for-mobile{
        display: none;
    }
    @media(max-width: 991px){
        .for-mobile{
            display: block;
        }
        ul{
            display: none;
        }
    }

    .css-13cymwt-control{
        background-color: ${primary};
        border: none;
    }
    .css-p60uwv-control{
        padding-left: 15px;
        padding-bottom: 15px;
        padding-top: 10px;
    }
    .css-1u9des2-indicatorSeparator{
        display: none;
    }
    .css-1jqq78o-placeholder{
        color: #FFF;
    }
    .css-1dimb5e-singleValue{
        color: #FFF;
    }
    .css-19bb58m{
        color: #FFF;
        input{
            color: #FFF;
            &::placeholder{
                color: #FFF;
            }
        }
    }
`;

export default MyComponent;
